import React from "react";
import { Box, Tooltip } from "@mui/material";
import { riskProfileSegments } from "../../utils/inventoryRiskPageDefaults";

/** Stacked bar of a product's SKUs per risk bucket (worst first). */
export const RiskProfileBar = ({ row, ui, width = 96 }) => {
  const segments = riskProfileSegments(row);
  if (!segments.length) return <Box sx={{ color: ui.colors.textTertiary }}>—</Box>;
  return (
    <Tooltip title={segments.map((s) => `${s.short}: ${s.count}`).join(" · ")}>
      <Box
        sx={{
          display: "flex",
          gap: "2px",
          width,
          height: 10,
          borderRadius: "3px",
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        {segments.map((segment) => (
          <Box
            key={segment.key}
            sx={{ width: `${segment.pct}%`, backgroundColor: segment.color, minWidth: 3 }}
          />
        ))}
      </Box>
    </Tooltip>
  );
};

/** "● 1 Critical · ● 2 At Risk · ● 3 Healthy" — why the product is listed. */
export const RiskCounts = ({ row, ui, fontSize = 11.5 }) => {
  const segments = riskProfileSegments(row);
  if (!segments.length) return null;
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        columnGap: 1.1,
        rowGap: 0.25,
        fontSize,
        color: ui.colors.textSecondary,
        lineHeight: 1.4,
      }}
    >
      {segments.map((segment) => (
        <Box
          key={segment.key}
          component="span"
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap" }}
        >
          <Box
            component="span"
            sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: segment.color }}
          />
          <Box component="span" sx={{ fontWeight: 700, color: ui.colors.textPrimary }}>
            {segment.count}
          </Box>
          {segment.short}
        </Box>
      ))}
    </Box>
  );
};

/** Small colored risk label for one SKU. */
export const RiskLabel = ({ segment, ui }) =>
  segment ? (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        whiteSpace: "nowrap",
        fontWeight: 600,
        color: ui.colors.textPrimary,
      }}
    >
      <Box
        component="span"
        sx={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: segment.color }}
      />
      {segment.short}
    </Box>
  ) : null;
